// Communication with Google Tag Manager's data layer is handled here.
//
// This file is loaded on V2 pages. A duplicate file for V1 pages can be found here:
// `app/assets/javascripts/common/google-tag-manager.js`
//
// `window.dataLayer` is initialized in production environments only, from this file:
// `app/views/adwerx/common/_google_tag_manager.html.erb`

const actionField = (campaignId, transactionAmount) => ({
  id: campaignId,
  affiliation: "Adwerx",
  revenue: transactionAmount,
  tax: "0.00",
  shipping: "0.00"
});

const products = (campaignType, campaignVertical, transactionAmount) => [
  {
    name: campaignType,
    id: campaignType,
    price: transactionAmount,
    category: campaignVertical,
    quantity: "1"
  }
];

export const googleTagManagerTrackFunnelStart = () => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ event: "formStart" });

  console.log("Google Tag Manager: formStart");
};

export const googleTagManagerTrackTransaction = (
  campaignId,
  campaignType,
  campaignVertical,
  transactionAmount,
  purchasedWithCreditCard
) => {
  if (!purchasedWithCreditCard) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "transaction",
    ecommerce: {
      purchase: {
        actionField: actionField(campaignId, transactionAmount),
        products: products(campaignType, campaignVertical, transactionAmount)
      }
    }
  });

  console.log("Google Tag Manager: transaction");
};
